

type AlertVariant = 'info' | 'success' | 'warning' | 'danger'

interface AlertBannerProps {
  variant?: AlertVariant
  title: string
  description?: string
  action?: { label: string; onClick: () => void }
  onDismiss?: () => void
}

const config: Record<AlertVariant, { bg: string; border: string; icon: string }> = {
  info: { bg: 'bg-brand-accent/10', border: 'border-brand-accent/30', icon: 'ℹ' },
  success: { bg: 'bg-brand-success/10', border: 'border-brand-success/30', icon: '✓' },
  warning: { bg: 'bg-brand-warning/10', border: 'border-brand-warning/30', icon: '⚠' },
  danger: { bg: 'bg-brand-danger/10', border: 'border-brand-danger/30', icon: '✕' },
}

export function AlertBanner({ variant = 'info', title, description, action, onDismiss }: AlertBannerProps) {
  const c = config[variant]
  return (
    <div className={`${c.bg} border ${c.border} rounded-xl p-4 flex items-start gap-3 animate-fade-in`}>
      <span className="text-sm mt-0.5">{c.icon}</span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-text-primary">{title}</p>
        {description && <p className="text-xs text-text-secondary mt-0.5">{description}</p>}
        {action && (
          <button onClick={action.onClick} className="mt-2 text-xs font-semibold text-brand-accent hover:underline">
            {action.label} →
          </button>
        )}
      </div>
      {onDismiss && (
        <button onClick={onDismiss} className="text-text-muted hover:text-text-primary text-xs">✕</button>
      )}
    </div>
  )
}
